import { render, staticRenderFns } from "./ModalGift.vue?vue&type=template&id=d31ef9a2&scoped=true"
import script from "./ModalGift.vue?vue&type=script&lang=js"
export * from "./ModalGift.vue?vue&type=script&lang=js"
import style0 from "./ModalGift.vue?vue&type=style&index=0&id=d31ef9a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31ef9a2",
  null
  
)

export default component.exports